import React from 'react';
import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const ModalConfirmDelete = ({
  handleSubmitDelete,
  closeModalChangeStatus,
  titleConfirm = 'Xóa',
  messageDelete = 'Bạn có chắc chắn xóa',
}) => {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          marginTop: '10px',
        }}
      >
        <Box sx={{ marginLeft: 'auto', display: 'flex', flexDirection: 'row' }}>
          <BtnCancel onClick={closeModalChangeStatus}>Hủy</BtnCancel>
          <BtnAccept onClick={() => handleSubmitDelete()}>Xác nhận</BtnAccept>
        </Box>
      </Box>
    </Box>
  );
};

export { ModalConfirmDelete };

const BtnCancel = styled(Button)(({ theme }) => ({
  borderRadius: '20px',
  marginLeft: '8px',
  color: '#FFFFFF',
  backgroundColor: '#555',
  opacity: 0.7,
  '.MuiButton-endIcon': {
    marginLeft: '0px',
  },
  '&:hover': {
    backgroundColor: '#555',
    opacity: 0.5,
  },
  padding: '6px 16px 2px 16px',
  textTransform: 'none',
  fontWeight: 'normal',
}));

const BtnAccept = styled(Button)(({ theme }) => ({
  borderRadius: '20px',
  marginLeft: '8px',
  color: '#FFFFFF',
  backgroundColor: '#13265b',
  '.MuiButton-endIcon': {
    marginLeft: '0px',
  },
  '&:hover': {
    backgroundColor: '#13265b',
    opacity: 0.7,
  },
  padding: '6px 16px 2px 16px',
  textTransform: 'none',
  fontWeight: 'normal',
}));
